"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withTrackerContext = void 0;
const data_layer_1 = require("../data-layer");
/**
 * Cria as funções de tracking a partir de um contexto.
 * @param trackerContext - Contexto de tracking criado pela função `createTrackerContext`
 * @public
 * @example
 * const appContext = createTrackerContext({ appName: 'warren-website' })
 * const Tracker = withTrackerContext(appContext)
 * Tracker.trackEvent({ action: '.', label: '..', category: '...' })
 * const trackMenuEvent = Tracker.trackerWithDefaultProps({ category: 'menu' })
 */
function withTrackerContext({ context }) {
    function trackEvent(eventProps) {
        (0, data_layer_1.validateDataLayer)();
        (0, data_layer_1.addDataLayerEvent)({
            ...context.value,
            ...eventProps,
            event: 'eventListener'
        });
    }
    function trackerWithDefaultProps(defaultProps) {
        return (remainingProps) => {
            trackEvent({
                ...context.value,
                ...defaultProps,
                ...remainingProps
            });
        };
    }
    return {
        trackEvent,
        trackerWithDefaultProps
    };
}
exports.withTrackerContext = withTrackerContext;
//# sourceMappingURL=with-tracker.js.map